import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderOne from './HeaderTwo';
import FooterOne from './BottomFooter'; // Import your footer component

const NotFound = () => {
  const navigate = useNavigate();

  // Inline styles object
  const styles = {
    pageWrapper: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: '#f8f9fa',
    },

    mainContent: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      position: 'relative',
      overflow: 'hidden',
background: 'linear-gradient(135deg, rgb(238 239 244) 0%)'
      
    },

    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, rgb(238 239 244) 0%)',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    
    backgroundPattern: {
      position: 'absolute',
      width: '200%',
      height: '200%',
      background: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
      backgroundSize: '50px 50px',
      animation: 'moveBackground 20s linear infinite',
      top: 0,
      left: 0,
    },
    
    content: {
      textAlign: 'center',
      color: '#37aad7',
      zIndex: 1,
      maxWidth: '600px',
      animation: 'fadeInUp 0.8s ease-out',
    },
    
    errorAnimation: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      marginBottom: '30px',
    },
    
    number: {
      fontSize: '120px',
      fontWeight: 'bold',
      textShadow: '0 10px 30px rgba(0,0,0,0.3)',
      animation: 'bounce 2s ease-in-out infinite',
    },
    
    printerContainer: {
      position: 'relative',
      fontSize: '120px',
      fontWeight: 'bold',
      color: 'transparent',
      width: '120px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    printerIcon: {
      fontSize: '80px',
      color: 'white',
      animation: 'printRotate 3s ease-in-out infinite',
    },
    
    paperFlying: {
      display: 'flex',
      justifyContent: 'center',
      gap: '30px',
      marginBottom: '30px',
      fontSize: '30px',
    },
    
    paper: {
      color: 'rgba(255,255,255,0.8)',
      animation: 'flyPaper 3s ease-in-out infinite',
    },
    
    title: {
      fontSize: '48px',
      marginBottom: '20px',
      fontWeight: 700,
      textShadow: '0 5px 20px rgba(0,0,0,0.3)',
      margin: '0 0 20px 0',
    },
    
    message: {
      fontSize: '18px',
      marginBottom: '40px',
      lineHeight: '1.6',
      opacity: 0.95,
    },
    
    actionButtons: {
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      marginBottom: '40px',
      flexWrap: 'wrap',
    },
    
    button: {
      padding: '10px 15px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '50px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontWeight: 600,
    },
    
    btnHome: {
      background: 'white',
      color: '#3bafd9ff',
    },
    
    btnBack: {
      background: 'rgba(255, 255, 255, 0.74)',
      color: '#3bafd9ff',
      border: '2px solid white',
    },
    
    helpfulLinks: {
      background: 'rgba(255,255,255,0.1)',
      padding: '30px',
      borderRadius: '15px',
      backdropFilter: 'blur(10px)',
    },
    
    helpfulTitle: {
      marginBottom: '20px',
      fontSize: '20px',
      margin: '0 0 20px 0',
    },
    
    linksList: {
      listStyle: 'none',
      padding: 0,
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      flexWrap: 'wrap',
      margin: 0,
    },
    
    linkItem: {
      color: 'white',
      textDecoration: 'none',
      padding: '10px 20px',
      border: '2px solid white',
      borderRadius: '25px',
      transition: 'all 0.3s ease',
      display: 'inline-block',
    },
  };

  // CSS animations injected once
  React.useEffect(() => {
    if (!document.getElementById('notfound-animations')) {
      const style = document.createElement('style');
      style.id = 'notfound-animations';
      style.textContent = `
        @keyframes moveBackground {
          0% { transform: translate(0, 0); }
          100% { transform: translate(50px, 50px); }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes printRotate {
          0%, 100% { transform: rotate(0deg) scale(1); }
          25% { transform: rotate(-10deg) scale(1.1); }
          75% { transform: rotate(10deg) scale(1.1); }
        }
        
        @keyframes flyPaper {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
            opacity: 0.8;
          }
          50% {
            transform: translateY(-30px) rotate(15deg);
            opacity: 1;
          }
        }
        
        .hover-home:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }
        
        .hover-back:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }
        
        .hover-link:hover {
          background: white;
          color: #667eea;
          transform: scale(1.05);
        }
        
        @media (max-width: 768px) {
          .error-number { font-size: 80px !important; }
          .printer-icon-mobile { font-size: 50px !important; }
          .error-title-mobile { font-size: 32px !important; }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={styles.pageWrapper}>
      {/* HEADER COMPONENT */}
      <HeaderOne />

      {/* MAIN CONTENT */}
      <main style={styles.mainContent}>
        <div style={styles.backgroundPattern}></div>
        
        <div style={styles.content}>
          <div style={styles.errorAnimation}>
            <div style={{...styles.number, animationDelay: '0s'}} className="error-number">4</div>
            
            <div style={styles.printerContainer}>
              <div style={styles.printerIcon} className="printer-icon-mobile">
                🖨️
              </div>
            </div>
            
            <div style={{...styles.number, animationDelay: '0.3s'}} className="error-number">4</div>
          </div>
          
         
          <h1 style={styles.title} className="error-title-mobile">Oops! Page Not Found</h1>
          <p style={styles.message}>
            Looks like this page got lost in the print queue! 
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div style={styles.actionButtons}>
            <button 
              onClick={() => navigate('/')} 
              style={{...styles.button, ...styles.btnHome}}
              className="hover-home"
            >
              Home
            </button>
            <button 
              onClick={() => navigate(-1)} 
              style={{...styles.button, ...styles.btnBack}}
              className="hover-back"
            >
               Back
            </button>
          </div>
        </div>
      </main>

      {/* FOOTER COMPONENT */}
      <FooterOne />
    </div>
  );
};

export default NotFound;
